'use client'
import dynamic from 'next/dynamic'

const CommonScreenSearchbar = dynamic(
  () => import('@/screens/common-sceen-searchbar').then((m) => ({ default: m.CommonScreenSearchbar })),
  { ssr: false }
)

export default function DeferredCommonSearchbar() {
  return <CommonScreenSearchbar />
}
